/* eslint-disable @typescript-eslint/no-explicit-any */
import ImageOptimize from '@/components/ImageOptimize'
import { useNotification } from '@/containers'
import type { BaseSlug } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'

export interface ProductProps {
  thumbnail: string
  slugs: BaseSlug
  className?: string
  name: { vi: string; en: string }
}

const ProductCardImage = ({
  thumbnail,
  slugs,
  className,
  name,
}: ProductProps) => {
  const { systemConfig } = useNotification()

  return (
    <div className={`${className || ''}`}>
      <Link href={'/' + getTranslate(slugs?.value) + slugs?.postfix}>
        <ImageOptimize
          className='productImage aspect-square w-full object-contain transition-all group-hover/card:scale-110'
          src={
            thumbnail ||
            systemConfig?.imagePlaceholder ||
            process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
            ''
          }
          alt={getTranslate(name)}
          width={160}
          height={160}
          loading='lazy'
          thumbnail
        />
      </Link>
    </div>
  )
}

export default ProductCardImage
